let messageApi = null;
let notificationApi = null;

export function setMessageApi(api) {
  messageApi = api;
}

export function setNotificationApi(api) {
  notificationApi = api;
}

export function showError(msg) {
  if (messageApi) {
    messageApi.error(msg);
  } else {
    // Fallback if AppProvider not mounted yet
    console.error('AntD message API not initialized:', msg);
  }
}

export function showWarning(msg) {
  if (messageApi) {
    messageApi.warning(msg);
  } else {
    // Fallback if AppProvider not mounted yet
    console.error('AntD message API not initialized:', msg);
  }
}

export function showSuccess(msg) {
  if (messageApi) {
    messageApi.success(msg);
  } else {
    console.log('SUCCESS:', msg);
  }
}

export function showInfo(msg) {
  if (messageApi) {
    messageApi.info(msg);
  } else {
    console.log('INFO:', msg);
  }
}

export function showSuccessNotification(title, description) {
  if (notificationApi) {
    notificationApi.success({ message: title, description, placement: 'topRight' });
  } else {
    // Fallback if AppProvider not mounted yet
    console.log('SUCCESS:', title, description);
  }
}

export function showErrorNotification(title, description) {
  if (notificationApi) {
    notificationApi.error({ message: title, description, placement: 'topRight' });
  } else {
    // Fallback if AppProvider not mounted yet
    console.error('AntD notification API not initialized:', title, description);
  }
}
